module.exports = __webpack_public_path__ + "static/media/CH_copy.f6bbf9ee.png";